import React from 'react';
import { FaTruck, FaWarehouse } from 'react-icons/fa';

const TypeSelector = ({ selectedType, setSelectedType }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-3">Location Type</label>
      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={() => setSelectedType('Dispatch')}
          className={`flex items-center justify-center px-4 py-3 rounded-md font-medium transition-all duration-200 ${
            selectedType === 'Dispatch'
              ? 'bg-primary-500 text-white shadow-lg'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <FaTruck className="mr-2" />
          Dispatch
        </button>

        <button
          onClick={() => setSelectedType('Receipt')}
          className={`flex items-center justify-center px-4 py-3 rounded-md font-medium transition-all duration-200 ${
            selectedType === 'Receipt'
              ? 'bg-primary-500 text-white shadow-lg'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <FaWarehouse className="mr-2" />
          Receipt
        </button>
      </div>
    </div>
  );
};

export default TypeSelector;
